export default {
  getTimeZoneName(countryId) {
    switch (countryId) {
      case 'ar':
        return 'America/Argentina/Buenos_Aires'
      case 'cl':
        return 'America/Santiago'
      case 'uy':
        return 'America/Montevideo'
      default:
        return 'America/Argentina/Buenos_Aires'
    }
  }
}
